<form class="kLoginForm" [formGroup]="_forgotPasswordForm" (submit)="_resetPassword($event)">
  <h1>{{ 'app.login.forgotPassword.title' | translate }}</h1>

  <ng-container *ngIf="_displayEmailField">
    <p>
      {{ 'app.login.forgotPassword.instructions' | translate }}
      <span *ngIf="!_contactUsLinkExists">{{ 'app.login.forgotPassword.contactUs' | translate }}</span>
      <a *ngIf="_contactUsLinkExists" (click)="_openContactUs()">{{
        'app.login.forgotPassword.contactUs' | translate
      }}</a>
    </p>

    <div>
      <input
        pInputText
        autocomplete="off"
        [placeholder]="'app.login.forgotPassword.placeholder' | translate"
        [formControl]="_emailField"
        [ngClass]="{
          'has-error': errorMessage || _emailValidationMessage,
          'has-success': _emailField.valid && _emailField.touched
        }"
        [kTooltip]="_emailValidationMessage | translate"
        placement="right"
      />
    </div>

    <p *ngIf="errorMessage" class="kErrorMessage" [innerHTML]="errorMessage"></p>

    <div>
      <button class="kButtonDefault" pButton [label]="_resetBtnText | translate" [disabled]="inProgress"></button>
    </div>
  </ng-container>
  <ng-container *ngIf="!_displayEmailField">
    <p class="kLoginFormEmailSentTitle">
      <i class="kIconcheck_large kLoginFormEmailSentIcon"></i>
      {{ 'app.login.forgotPassword.sent.emailSent' | translate }}
    </p>
    <p>{{ 'app.login.forgotPassword.sent.instructions' | translate }}</p>
    <p class="kRedirectTo">
      {{ 'app.login.forgotPassword.sent.redirectTo' | translate }}&nbsp;
      <a (click)="_openLogin()" class="kUnderlined">{{ 'app.login.forgotPassword.sent.login' | translate }}</a>
    </p>
  </ng-container>
</form>
